/**
 * Service layer — Permit Portals (Supabase-backed)
 *
 * Wraps /api/permit-portals (Clerk-authed). One portal can serve multiple permits.
 * Passwords are returned by the API (authenticated users only).
 */

async function call(method, body, qs) {
  const token = await window.__clerkGetToken()
  const url = '/api/permit-portals' + (qs ? '?' + qs : '')
  const res = await fetch(url, {
    method,
    headers: method === 'GET'
      ? { 'Authorization': 'Bearer ' + token }
      : { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    body: method === 'GET' ? undefined : JSON.stringify(body),
  })
  if (!res.ok) {
    const b = await res.json().catch(() => ({}))
    throw new Error(b.error || 'Portal request failed: ' + res.status)
  }
  return res.json()
}

/** Get the portal linked to a permit. Returns { portal } (portal may be null). */
export function getPortalForPermit(permitAirtableId) {
  return call('GET', null, 'permitId=' + encodeURIComponent(permitAirtableId))
}

/** Create a new portal, optionally linking it to a permit immediately. */
export function createPortal(fields, permitAirtableId) {
  return call('POST', { action: 'create', fields, permitAirtableId }).then(d => d.portal)
}

/** Update an existing portal's fields. */
export function updatePortal(portalId, fields) {
  return call('POST', { action: 'update', portalId, fields }).then(d => d.ok)
}

/** Link a portal to an additional permit. */
export function linkPortalToPermit(portalId, permitAirtableId) {
  return call('POST', { action: 'linkPermit', portalId, permitAirtableId }).then(d => d.ok)
}
